import { toast } from '~/components/Toast/Toast';

export const copyToClipboard = async (text?: string, toastTitle?: string) => {
  if (!text) {
    return;
  }
  await navigator.clipboard.writeText(text);
  toast({
    title: toastTitle ?? 'Copied',
    type: 'info',
  });
};
